__webpack_require__.p = "/update-pdfjs/onboarding/";